module.exports = __webpack_public_path__ + "static/media/up-icon.a5af81aa.svg";